import type { TranslationKeys } from "./en"

export const es: TranslationKeys = {
  // App
  appName: "DevPulse",

  // Navigation
  navDashboard: "Panel",
  navContributors: "Contribuidores",
  navTeams: "Equipos",
  navRepositories: "Repositorios",

  // Views
  viewOrganization: "Organización",
  viewGroup: "Grupo",
  viewIndividual: "Individual",
  viewSelectPlaceholder: "Seleccionar vista",

  // Common
  loading: "Cargando datos...",
  authenticating: "Autenticando...",
  loadingError: "Error al cargar datos",
  authError: "Error de autenticación",
  retry: "Reintentar",
  tryAgain: "Intentar de nuevo",
  profile: "Perfil",
  settings: "Configuración",
  logout: "Cerrar sesión",
  selectTimeRange: "Seleccionar período",
  selectTeam: "Seleccionar un equipo...",
  selectDeveloper: "Seleccionar un desarrollador...",

  // Time ranges
  timeLast7Days: "Últimos 7 días",
  timeLast30Days: "Últimos 30 días",
  timeAll: "Todos",

  // Dashboard titles
  dashboardOrganizationTitle: "Panel de Organización",
  dashboardOrganizationSubtitle:
    "Resumen de métricas de desarrollo en todos los repositorios y miembros del equipo",
  dashboardTeamTitle: "Panel de Equipo",
  dashboardTeamSubtitle: "Métricas de desarrollo para miembros del equipo {team}",
  dashboardTeamNoData:
    "No hay equipos configurados. Agregue datos de equipo para ver métricas específicas del equipo.",
  dashboardIndividualTitle: "Panel Individual",
  dashboardIndividualSubtitle: "Métricas de desarrollo para {author}",
  dashboardIndividualNoData:
    "No se encontraron autores. Cargue datos para ver métricas individuales.",

  // Contributors page
  contributorsTitle: "Contribuidores",
  contributorsSubtitle: "Analizar rendimiento y actividad de contribuidores",
  contributorsNoData: "No hay datos de contribuidores disponibles para el período seleccionado.",

  // Teams page
  teamsTitle: "Equipos",
  teamsSubtitle: "Analizar rendimiento y actividad del equipo",
  teamsNoData: "No hay datos de equipo disponibles para el período seleccionado.",

  // Repositories page
  repositoriesTitle: "Repositorios",
  repositoriesSubtitle: "Analizar rendimiento y actividad del repositorio",
  repositoriesNoData: "No hay datos de repositorio disponibles para el período seleccionado.",
  repositoriesScoreTitle: "Puntuación de Complejidad de Commits del Repositorio",
  repositoriesScoreDescription:
    "Puntuación total de complejidad de todos los commits por repositorio.",
  repositoriesPRsTitle: "Pull Requests del Repositorio",
  repositoriesPRsDescription: "Número de pull requests fusionados por repositorio.",

  // DORA Metrics page
  doraMetricsTitle: "Métricas DORA",
  doraMetricsSubtitle:
    "Métricas de DevOps Research and Assessment (DORA) para medir el rendimiento de entrega de software",
  doraNoDataTitle: "No hay datos de métricas DORA disponibles",
  doraNoDataDescription:
    "Las métricas DORA requieren datos de lanzamientos, pull requests y commits. Asegúrese de que los datos estén recopilados y exportados.",
  doraMissingDataTitle: "Datos faltantes para métricas DORA completas",
  doraMissingDataDescription:
    "Los siguientes puntos de datos faltan o están incompletos para el cálculo completo de métricas DORA:",
  doraDataLimitationsTitle: "Limitaciones de datos",
  doraDataLimitationsDescription:
    "Las métricas DORA mostradas se calculan a partir de datos disponibles, que tienen algunas limitaciones:",
  doraOverallPerformance: "Nivel general de rendimiento DORA",
  doraOverallDescription:
    "Basado en las cuatro métricas clave, el nivel de rendimiento general de su equipo se calcula según los puntos de referencia DORA.",
  doraDeploymentFrequency: "Frecuencia de despliegue",
  doraLeadTime: "Tiempo de espera para cambios",
  doraChangeFailureRate: "Tasa de fallos de cambios",
  doraTimeToRestore: "Tiempo para restaurar el servicio",
  doraPerMonth: "por mes",
  doraDays: "días",
  doraHours: "horas",
  doraDeploymentsByMonth: "Despliegues por mes",
  doraLeadTimeTrend: "Tendencia de tiempo de espera",
  doraFailureRateTrend: "Tendencia de tasa de fallos",
  doraRestoreTimeTrend: "Tendencia de tiempo de restauración",
  doraDeploymentFrequencyDetail: "Frecuencia de despliegue a lo largo del tiempo",
  doraDeploymentFrequencyDetailDescription: "Número de despliegues por mes",
  doraLeadTimeDetail: "Tiempo de espera para cambios a lo largo del tiempo",
  doraLeadTimeDetailDescription:
    "Tiempo promedio desde la creación del PR hasta la fusión (en horas) por mes",
  doraMethodologyTitle: "Metodología y fuentes de datos",
  doraDeploymentFrequencyMethodology:
    "Calculado a partir de lanzamientos publicados (excluyendo borradores y pre-lanzamientos) en la tabla de base de datos de lanzamientos.",
  doraLeadTimeMethodology:
    "Calculado como el tiempo entre la creación y fusión del pull request, medido desde la tabla pull_requests.",
  doraChangeFailureRateMethodology:
    "Estimado detectando commits de corrección de errores o reversión dentro de los 7 días posteriores a un lanzamiento. Esta es una aproximación ya que no tenemos seguimiento explícito de fallos de despliegue.",
  doraTimeToRestoreMethodology:
    "Estimado como el tiempo entre un lanzamiento y el primer commit de corrección de errores/reversión. Esta es una aproximación ya que no tenemos datos de gestión de incidentes.",

  // DORA Performance Levels
  doraLevelElite: "ÉLITE",
  doraLevelHigh: "ALTO",
  doraLevelMedium: "MEDIO",
  doraLevelLow: "BAJO",

  // DORA Missing Data Points
  doraMissingReleases: "Datos de lanzamientos para frecuencia de despliegue",
  doraMissingPullRequests: "Datos de pull requests para cálculo de tiempo de entrega",
  doraMissingCommits: "Datos de commits para análisis de fallos",
  doraMissingDeployments: "Datos de despliegue (Fase 2) - usando lanzamientos como proxy",
  doraMissingWorkflowRuns:
    "Datos de flujo de trabajo CI/CD (Fase 2) - visibilidad limitada del pipeline",
  doraMissingIncidents:
    "Datos de seguimiento de incidentes (Fase 3) - usando commits de corrección como proxy",

  error: "Error",

  // Tabs
  tabPerformance: "Rendimiento",
  tabScore: "Puntuación",
  tabPRs: "PRs",
  tabIssues: "Issues",
  tabActivity: "Actividad",
  tabReleases: "Lanzamientos",

  // Activity
  recentActivity: "Actividad Reciente",

  // Releases tab
  releasesTitle: "Lanzamientos (Últimas 12 Semanas)",
  releasesDescription: "Número total de lanzamientos publicados en todos los repositorios",
  releasesChartTitle: "Lanzamientos por Repositorio (Últimas 6 Semanas)",
  releasesChartDescription: "Actividad semanal de lanzamientos por repositorio",

  // Performance tab
  performanceScoreTitle: "Puntuación de Rendimiento General (0-100)",
  performanceScoreDescription:
    "Una métrica integral que combina calidad del código (30%), velocidad de entrega (25%), impacto del código (20%), resolución de problemas (15%) y versatilidad del trabajo (10%).",
  performanceScoreAverage: "Promedio: {value}",
  performanceScoreComparison:
    " — El porcentaje muestra cómo se compara cada contribuidor con este promedio.",

  performanceScoreTeamTitle: "Puntuación de Rendimiento General del Equipo (0-100)",
  performanceScoreTeamDescription:
    "Puntuación de rendimiento agregada que combina las contribuciones de todos los miembros del equipo en calidad del código, velocidad de entrega, impacto del código, resolución de problemas y versatilidad del trabajo.",

  // Score tab
  scoreTitle: "Puntuación de Complejidad de Commits",
  scoreDescription:
    "Mide la complejidad del código según archivos modificados, líneas cambiadas, cambios de funciones y complejidad ciclomática. Puntuaciones más altas indican contribuciones más desafiantes e impactantes.",
  scoreAverage: "Promedio: {value} puntos",
  scoreComparison: " — El porcentaje muestra cómo se compara cada contribuidor con este promedio.",

  scoreTeamTitle: "Puntuación de Complejidad de Commits del Equipo",
  scoreTeamDescription:
    "Puntuación de complejidad combinada de todos los commits de los miembros del equipo, midiendo el desafío técnico e impacto de los cambios de código. Puntuaciones más altas indican trabajo más complejo e impactante.",

  // PRs tab
  prsTitle: "Pull Requests Fusionados",
  prsDescription:
    "Número total de pull requests fusionados exitosamente. Esta métrica refleja la participación en revisión de código, colaboración y entrega exitosa de características y correcciones.",
  prsAverage: "Promedio: {value} PRs",
  prsComparison: " — El porcentaje muestra cómo se compara cada contribuidor con este promedio.",

  prsTeamTitle: "Pull Requests Fusionados del Equipo",
  prsTeamDescription:
    "Total de pull requests fusionados de todos los miembros del equipo. Esto refleja la colaboración del equipo, participación en revisión de código y entrega exitosa de características y correcciones.",

  // Performance tab - Insight cards
  insightMergedPRs: "PRs Fusionados",
  insightPRThroughput: "Rendimiento de PRs",
  insightFeatureCommits: "Commits de Funcionalidad",
  insightFeatures: "Funcionalidades",
  insightBugfixCommits: "Commits de Corrección",
  insightBugfixes: "Correcciones",
  insightMaintenanceCommits: "Commits de Mantenimiento",
  insightMaintenance: "Mantenimiento",

  // Chart titles
  chartCommitsByClassification: "Commits por Clasificación",
  chartCommitsBySize: "Commits por Tamaño",
  chartCommitScoresByWeek: "Puntuaciones de Commits por Semana",
  chartCommitScoresByWeekDesc:
    "Puntuaciones totales de complejidad de commits agrupadas por semana y apiladas por tamaño",
  chartCommitScoresByClassificationWeek: "Puntuaciones de Commits por Clasificación",
  chartCommitScoresByClassificationWeekDesc:
    "Puntuaciones totales de complejidad de commits agrupadas por semana y apiladas por clasificación",
  chartPRsMerged: "PRs Fusionados Este Mes",
  chartPRsMergedByWeek: "PRs Fusionados por Semana",
  chartPRsMergedByWeekDesc:
    "Número de pull requests fusionados por semana durante las últimas 6 semanas",
  chartCodeChanges: "Cambios de Código",
  chartCodeChangesByWeek: "Cambios de Código por Semana",
  chartCodeChangesByWeekDesc: "Líneas añadidas y eliminadas de PRs fusionados por semana",
  chartIssuesCreated: "Issues Creados Este Mes",
  chartIssuesClosed: "Issues Cerrados Este Mes",
  chartActivityTitle: "Actividad de Contribución",
  chartActivityDescription:
    "Actividad de toda la organización incluyendo commits, pull requests e issues durante el último año",
  chartDetails: "Detalles",

  // Chart labels
  linesAdded: "Líneas Añadidas",
  linesRemoved: "Líneas Eliminadas",

  // Language selector
  languageLabel: "Idioma",
  languageEnglish: "Inglés",
  languageGerman: "Alemán",
  languageSpanish: "Español",
  languageChinese: "Chino",

  // DataTable
  dataTableFilters: "Filtros",
  dataTableFilterBy: "Filtrar por:",
  dataTableNoResults: "Sin resultados.",
  dataTableRowsPerPage: "Filas por página:",
  dataTablePage: "Página",
  dataTableOf: "de",
  dataTableTotalRows: "filas totales",
  dataTableSearch: "Buscar...",

  // Charts
  chartTrend: "Tendencia",
  chartDistribution: "Distribución",
  chartDate: "Fecha",

  // Quick insights
  quickInsightDate: "Últimos 7 días",
  quickInsightVsLastWeek: "vs {count} semana pasada",
  quickInsightVsLastMonth: "vs {count} mes pasado",

  // Data table column headers
  tableColumnTitle: "Título",
  tableColumnMessage: "Mensaje",
  tableColumnAuthor: "Autor",
  tableColumnDate: "Fecha",
  tableColumnCreated: "Creado",
  tableColumnScore: "Puntuación",
  tableColumnFiles: "Archivos",
  tableColumnAdditions: "+",
  tableColumnDeletions: "-",

  // Chart descriptions
  chartCommitsByClassificationDesc:
    "Número de commits agrupados por clasificación (tipo de commit) y apilados por tamaño de complejidad",
  chartCommitsBySizeDesc:
    "Número de commits agrupados por tamaño de complejidad y apilados por clasificación (tipo de commit)",
  chartCodeChangesDesc: "Líneas añadidas y eliminadas de los PRs fusionados",
  chartPRsMergedDesc: "{count} PRs fusionados (vs {prevCount} mes pasado)",
  chartIssuesCreatedDesc: "{count} issues creados (vs {prevCount} mes pasado)",
  chartIssuesClosedDesc: "{count} issues cerrados (vs {prevCount} mes pasado)",
}
